import theme from 'stories/utils/theme'
import RotatingReviews from 'stories/V1/sections/RotatingReviews'
import styled from 'styled-components'
import { getDefaultReviews } from 'lib/utils/university'

const MarginContainer = styled.div`
    padding: 20px 48px 30px 48px;
    background-color: ${theme.colors.darkBlackTransparent};
    @media (max-width: 860px) {
        padding: 0 16px;
    }
`

const ReviewsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    background-color: ${theme.colors.secondarySolidDark};
    border-radius: 48px;
    padding: 75px 0 50px;
    min-height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 740px) {
        padding: 40px 0 25px;
        gap: 0px;
        border-radius: ${theme.borderRadius.rounded};
    }
`

const UniversityReviews = () => {
    const topReviews = getDefaultReviews()
    return (
        <MarginContainer>
            <ReviewsContainer>
                <RotatingReviews reviews={topReviews} />
            </ReviewsContainer>
        </MarginContainer>
    )
}

export default UniversityReviews
